export type DroneKey =
  | 'C'
  | 'C#'
  | 'D'
  | 'D#'
  | 'E'
  | 'F'
  | 'F#'
  | 'G'
  | 'G#'
  | 'A'
  | 'A#'
  | 'B';

export type DroneInterval = 'single' | 'fifth' | 'oct5';

export type DroneOctave = 'low' | 'mid' | 'high';

export type DroneKeyWeight = 'primary' | 'secondary' | 'rare';

export type DroneKeyInfo = {
  note: DroneKey;
  enharmonic: string | null;
  weight: DroneKeyWeight;
  modes: string[];
  baseHz: number;
};

export type DroneIntervalInfo = {
  id: DroneInterval;
  label: string;
  hint: string;
};

export const DRONE_KEYS: readonly DroneKeyInfo[] = [
  { note: 'C', enharmonic: null, weight: 'secondary', modes: ['maj', 'mix'], baseHz: 261 },
  { note: 'C#', enharmonic: 'D♭', weight: 'rare', modes: ['maj', 'min'], baseHz: 277 },
  { note: 'D', enharmonic: null, weight: 'primary', modes: ['maj', 'mix', 'dor'], baseHz: 294 },
  { note: 'D#', enharmonic: 'E♭', weight: 'rare', modes: ['maj'], baseHz: 311 },
  { note: 'E', enharmonic: null, weight: 'primary', modes: ['dor', 'min', 'maj', 'phr'], baseHz: 330 },
  { note: 'F', enharmonic: null, weight: 'secondary', modes: ['maj', 'mix'], baseHz: 349 },
  { note: 'F#', enharmonic: 'G♭', weight: 'rare', modes: ['min', 'dor'], baseHz: 370 },
  { note: 'G', enharmonic: null, weight: 'primary', modes: ['maj', 'mix', 'dor'], baseHz: 392 },
  { note: 'G#', enharmonic: 'A♭', weight: 'rare', modes: ['maj'], baseHz: 415 },
  { note: 'A', enharmonic: null, weight: 'primary', modes: ['maj', 'mix', 'dor', 'min'], baseHz: 440 },
  { note: 'A#', enharmonic: 'B♭', weight: 'secondary', modes: ['maj'], baseHz: 466 },
  { note: 'B', enharmonic: null, weight: 'rare', modes: ['min', 'dor'], baseHz: 494 },
];

export const DRONE_INTERVALS: readonly DroneIntervalInfo[] = [
  { id: 'single', label: 'Single', hint: 'root only' },
  { id: 'fifth', label: 'Root + 5th', hint: 'pipe-style' },
  { id: 'oct5', label: '5th + octave', hint: 'full' },
];

export const DRONE_OCTAVES: readonly DroneOctave[] = ['low', 'mid', 'high'];
